import React from 'react';
import CategoryPageFaqsData from '../../../CategoryDetail/CategoryPageFaqsData';
import { DiscussionContainer } from './styled';

function CategoryFaqsData(props) {
  const { data } = props;
  const heading = data?.heading;
  const subHeading = data?.subHeading;
  const discussionList = data?.discussionList;
  const faqsData = discussionList?.map((discussion) => {
    return {
      questionName: discussion?.content?.message,
      acceptedAnswerText: discussion?.content?.commentData?.[0]?.message,
    };
  });

  return (
    <DiscussionContainer>
      <div className="headings">
        <h2>{heading}</h2>
        <h3>{subHeading}</h3>
      </div>
      <CategoryPageFaqsData faqsData={faqsData} hideHeading={true} />
      {/* {discussionList?.map((discussion, index) => {
                const question = discussion?.content?.message;
                const answer = discussion?.content?.commentData?.[0]?.message;
                const [acceptedAnswer, setAcceptedAnser] = useState(
                    answer?.slice(0, 104),
                );
                const handleClickShowMore = () => setAcceptedAnser(answer);
                return (
                    <div key={"discussion" + index} className="questionCover">
                        <div className="question"> Q-: {question}</div>
                        <div className="answer">
                            {" "}
                            A -: {acceptedAnswer}{" "}
                            {answer != acceptedAnswer ? (
                                <>
                                    ...{" "}
                                    <span
                                        onClick={handleClickShowMore}
                                        className="seeMore"
                                    >
                                        See More
                                    </span>
                                </>
                            ) : null}
                        </div>
                    </div>
                );
            })} */}
      <button className="viewAll "> View All Questions</button>
    </DiscussionContainer>
  );
}

export default CategoryFaqsData;
